<template>
  <v-overlay :value='!site.onamaeMmApiAvailable'>
    <v-card light>
      <v-card-text class='body-1'>
        <p>お名前.comメールマーケティング APIキーの設定がされていません。</p>
        <p>
          <router-link :to="{ name: 'adminSettings' }">設定ページ</router-link>
          → APIキー から設定をしてください。
        </p>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ApiKeyPromptOverlayContainer',
  computed: {
    ...mapState({
      site: (state) =>
        state.SiteStore.site
    })
  }
}
</script>
